import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'clsx';
import styles from './ProgressBar.scss';

interface IProgressBarProps {
  steps: string[];
  currentStep: string;
}

class ProgressBar extends Component<IProgressBarProps> {
  static contextTypes = {
    deviceType: PropTypes.string,
  };
  render() {
    const { steps } = this.props;
    return (
      <div
        key="progress-bar"
        // @ts-expect-error
        className={cn(styles.steps, this.context.deviceType === 'mobile' && styles.mobile)}
        data-hook="wcn-progress-bar"
      >
        {steps.map((step) => this.renderStep(step))}
      </div>
    );
  }

  renderStep(step) {
    const { steps, currentStep } = this.props;
    const index = steps.indexOf(step);
    const currentStepIndex = steps.indexOf(currentStep);
    const isActive = index <= currentStepIndex;
    return (
      <div
        key={`progress-bar-${index}`}
        className={isActive ? styles.activeStep : styles.inactiveStep}
        data-hook={isActive ? 'wcn-progress-bar-active-step' : 'wcn-progress-bar-inactive-step'}
      />
    );
  }
}

export default ProgressBar;
